module.exports = __webpack_public_path__ + "img/dlzndx.b3adb746.png";